import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30b18aeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card pt-2" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-excel me-2" }, null, -1))
const _hoisted_5 = {
  key: 1,
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "โครงการ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ปีงบประมาณ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ประเภทโครงการ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จังหวัด"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "สถานะ")
  ])
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["data-bs-content"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cube me-2" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-primary mb-3",
        disabled: _ctx.projects.length === 0,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.excelClick && _ctx.excelClick(...args)))
      }, [
        _hoisted_4,
        _createTextVNode("เอกสาร EXCEL ")
      ], 8, _hoisted_3),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "row-hover",
                  onClick: ($event: any) => (_ctx.selectedClick(project.id))
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", {
                    class: "column-name text-truncate",
                    "data-bs-toggle": "popover-project",
                    "data-bs-content": project.name
                  }, [
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(project.name), 1)
                  ], 8, _hoisted_8),
                  _createElementVNode("td", null, _toDisplayString(project.fiscalYear.name), 1),
                  _createElementVNode("td", null, _toDisplayString(project.projecType.name), 1),
                  _createElementVNode("td", null, _toDisplayString(project.province.name), 1),
                  _createElementVNode("td", null, [
                    (project.isCanceled)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "ยกเลิก"))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          style: _normalizeStyle({ color: project.projectStatus.color })
                        }, _toDisplayString(project.projectStatus.name), 5))
                  ])
                ], 8, _hoisted_7))
              }), 128))
            ])
          ], 512))
    ])
  ]))
}